<div>
  <div class="reg-close-wrap">
    <div class='reg-close-dialog-btn flex-center' mat-dialog-close>
      <img class="fltr-close-img" src="assets/images/innovations/pkg-dialog-close.png" alt="" />
    </div>
  </div>
<div class="company-details-wrap">
    <div class="company_logo-wrap">
      <img class="company_logo" [src]="companyLogo" alt=""/>
    </div>
  <div class="reg-company-wrap">
      <div class="reg-company-name">{{companyName}}</div>
  </div>
    <div *ngIf="companyStatus === 'Yes'; else elseBlock" class="recognitionIcon-cover-gigaguru">
      <img class="regonitionIcon-inner-gigaguru cmplogoo" alt="GIGA-GURU" src="assets/images/W-GIGA-GURU_25.png">
      <div class="company-stats">
        Gigaguru
      </div>
    </div>

    <ng-template #elseBlock>
      <div class="recognitionIcon-cover-sparking">
        <img class="regonitionIcon-inner-sparkingchange cmplogoo" alt="SPARKING-CHANGE" src="assets/images/W-SPARKING-CHANGE_25.png">
      <div class="company-stats">
        Sparking Change
      </div>
      </div>
    </ng-template>
</div>

</div>
